module.exports = __webpack_public_path__ + "static/media/palermo.c9d5f1ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clubs/palermo.jpg
// module id = 88
// module chunks = 0